// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { mergeWithCss, xScreen } from "@synd/XDL/Utilities";
import { modalButtonsActionStyles } from "@synd/XDL/Utilities/sharedStyles";
import { scheduleReminderModalStyles } from "@insite/content-library/Components/ScheduleReminderModal";
import { GridOffset } from "@insite/mobius/GridContainer";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

scheduleReminderModalStyles.modal = mergeWithCss(scheduleReminderModalStyles.modal, {
    sizeVariant: "medium",
    cssOverrides: {
        modalTitle: css`
            align-items: baseline;
        `,
    },
});

scheduleReminderModalStyles.titleText = {
    variant: "h3",
    css: css`
        &&& {
            margin-bottom: 0;
        }
    `,
};

scheduleReminderModalStyles.hintText = {
    ...fontConfig.smallSingleLine,
    css: css`
        margin-top: 5px;
    `,
};

scheduleReminderModalStyles.startDatePicker = {
    cssOverrides: {
        formInputWrapper: css`
            width: 100%;
        `,
    },
};

scheduleReminderModalStyles.endDatePicker = scheduleReminderModalStyles.startDatePicker;

scheduleReminderModalStyles.middleRowLeftColumnGridItem = {
    width: 12,
};

scheduleReminderModalStyles.middleRowRightColumnGridItem = {
    width: 12,
};

scheduleReminderModalStyles.frequencyRadioGroup = {
    horizontal: true,
    css: css`
        display: flex;
        & > ${TypographyStyle} {
            margin-right: 4px;
        }
    `,
};

scheduleReminderModalStyles.weeklyRadio = {};

scheduleReminderModalStyles.monthlyRadio = {};

scheduleReminderModalStyles.bottomRowGridItem = {
    width: 12,
};

scheduleReminderModalStyles.buttonsContainer = {
    gap: 0,
    css: css`
        & ${GridOffset} {
            flex-wrap: wrap;
            justify-content: space-between;
            ${xScreen("lte", "xs")} {
                flex-direction: column;
                gap: 10px;
            }
        }
    `,
};

scheduleReminderModalStyles.stopButtonGridItem = {
    css: css`
        flex-basis: auto;
        max-width: unset;
        order: 2;
        &&& {
            margin-left: 10px;
            ${xScreen("lte", "xs")} {
                margin-left: 0;
            }
        }
    `,
};

scheduleReminderModalStyles.cancelButtonGridItem = {
    css: css`
        flex-basis: auto;
        max-width: unset;
        &&& {
            margin-right: 10px;
        }
    `,
};

scheduleReminderModalStyles.scheduleButtonGridItem = {
    css: css`
        flex-basis: auto;
        max-width: unset;
    `,
};

scheduleReminderModalStyles.cancelButtonsGridItem = modalButtonsActionStyles.buttonsGridItem;

scheduleReminderModalStyles.dismissCancelButton = modalButtonsActionStyles.cancelButton;

scheduleReminderModalStyles.confirmCancelButton = modalButtonsActionStyles.submitButton;
